module.exports = __webpack_public_path__ + "static/media/CZ.844012f6.png";